module.exports = __webpack_public_path__ + "static/media/3.d0bbe49d.png";